<template>
  <div :class="computedClasses">
    <div class="space-y-1">
      <THeading
        v-if="title || $slots.title"
        :level="5"
        tag="h2"
      >
        <slot
          name="title"
        >
          {{ title }}
        </slot>
      </THeading>

      <TBody
        v-if="subtitle || $slots.subtitle"
        tag="div"
        variant="muted"
      >
        <slot
          name="subtitle"
        >
          {{ subtitle }}
        </slot>
      </TBody>
    </div>

    <div v-if="$slots.actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  title?: string
  subtitle?: string
}>()

const computedClasses = computed(() => ([
  'flex items-start justify-between gap-2',
]))
</script>
